import validate from "/usr/src/app/content/n3-promos-e72e4faa-bb80-4c88-874b-03069857f3d2/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-e72e4faa-bb80-4c88-874b-03069857f3d2/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}